import { css } from '@emotion/core';

export const formEditorRootStyles = css`
  display: flex;
  width: 100%;
  height: 100%;
`;
